import React, { useEffect } from 'react'
import { Box } from '@mui/material'

const AdBanner = ({ 
  slot, 
  width = '100%', 
  height = '250px', 
  responsive = true,
  format = 'auto',
  style = {}
}) => {
  useEffect(() => {
    try {
      // AdSense script'i yüklendi mi kontrol et
      if (window.adsbygoogle) {
        window.adsbygoogle.push({})
      }
    } catch (error) {
      console.error('AdSense yükleme hatası:', error)
    }
  }, [])

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        my: 2,
        minHeight: height,
        ...style
      }}
    >
      <ins 
        className="adsbygoogle"
        style={{ 
          display: 'block',
          width: width,
          height: height,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '12px',
          ...style
        }}
        data-ad-client="ca-pub-XXXXXXXXXXXXXXXX" // Buraya AdSense Publisher ID'nizi koyun
        data-ad-slot={slot}
        data-ad-format={responsive ? format : undefined}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
    </Box>
  )
}

export default AdBanner
